module.exports = __webpack_public_path__ + "static/media/HDFC_F1.c86e14f1.txt";